// import React, { useEffect, useState } from "react";
// import BreadCrumb from "../components/BreadCrumb";
// import Meta from "../components/Meta";
// import watch from "../images/watch.jpg";
// import { AiFillDelete } from "react-icons/ai";
// import { Link } from "react-router-dom";
// import Container from "../components/Container";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   deleteCartProduct,
//   getUserCart,
//   updateCartProduct,
// } from "../features/user/userSlice";

// const Cart = () => {
//   const getTokenFromLocalStorage = localStorage.getItem("customer")
//     ? JSON.parse(localStorage.getItem("customer"))
//     : null;

//   const config2 = {
//     headers: {
//       Authorization: `Bearer ${
//         getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
//       }`,
//       Accept: "application/json",
//     },
//   };

//   const dispatch = useDispatch();

//   const [productupdateDetail, setProductupdateDetail] = useState(null);
//   const [totalAmount, setTotalAmount] = useState(null);
//   const userCartState = useSelector((state) => state.auth.cartProducts);

//   useEffect(() => {
//     dispatch(getUserCart(config2));
//   }, []);

//   useEffect(() => {
//     if (productupdateDetail !== null) {
//       dispatch(
//         updateCartProduct({
//           cartItemId: productupdateDetail?.cartItemId,
//           quantity: productupdateDetail?.quantity,
//         })
//       );
//       setTimeout(() => {
//         dispatch(getUserCart(config2));
//       }, 200);
//     }
//   }, [productupdateDetail]);

//   const deleteACartProduct = (id) => {
//     dispatch(deleteCartProduct({ id: id, config2: config2 }));
//     setTimeout(() => {
//       dispatch(getUserCart(config2));
//     }, 200);
//   };

//   useEffect(() => {
//     let sum = 0;
//     for (let index = 0; index < userCartState?.length; index++) {
//       sum =
//         sum +
//         Number(userCartState[index].quantity) * userCartState[index].price;
//       setTotalAmount(sum);
//     }
//   }, [userCartState]);

//   return (
//     <>
//       <Meta title={"Cart"} />
//       <BreadCrumb title="Cart" />
//       <Container class1="cart-wrapper home-wrapper-2 py-5">
//         <div className="row">
//           <div className="col-12">
//             <div className="cart-header py-3 d-flex justify-content-between align-items-center">
//               <h4 className="cart-col-1">Product</h4>
//               <h4 className="cart-col-2">Price</h4>
//               <h4 className="cart-col-3">Quantity</h4>
//               <h4 className="cart-col-4">Total</h4>
//             </div>
//             {userCartState &&
//               userCartState?.map((item, index) => {
//                 return (
//                   <div
//                     key={index}
//                     className="cart-data py-3 mb-2 d-flex justify-content-between align-items-center"
//                   >
//                     <div className="cart-col-1 gap-15 d-flex align-items-center">
//                       <div className="w-25">
//                         <img
//                           // src={item?.productId.images[0].url}
//                           className="img-fluid"
//                           alt="product image"
//                         />
//                       </div>
//                       <div className="w-75">
//                         <p>{item?.productId.title}</p>

//                         <p className="d-flex gap-3">
//                           Color:
//                           <ul className="colors ps-0">
//                             <li
//                               style={{ backgroundColor: item?.color.title }}
//                             ></li>
//                           </ul>
//                         </p>
//                       </div>
//                     </div>
//                     <div className="cart-col-2">
//                       <h5 className="price">Rs. {item?.price}</h5>
//                     </div>
//                     <div className="cart-col-3 d-flex align-items-center gap-15">
//                       <div>
//                         <input
//                           className="form-control"
//                           type="number"
//                           name={"quantity" + item?._id}
//                           min={1}
//                           max={10}
//                           id={"card" + item?._id}
//                           value={item?.quantity}
//                           onChange={(e) => {
//                             setProductupdateDetail({
//                               cartItemId: item?._id,
//                               quantity: e.target.value,
//                             });
//                           }}
//                         />
//                       </div>
//                       <div>
//                         <AiFillDelete
//                           onClick={() => {
//                             deleteACartProduct(item?._id);
//                           }}
//                           className="text-danger "
//                         />
//                       </div>
//                     </div>
//                     <div className="cart-col-4">
//                       <h5 className="price">
//                         Rs. {item?.quantity * item?.price}
//                       </h5>
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>
//           <div className="col-12 py-2 mt-4">
//             <div className="d-flex justify-content-between align-items-baseline">
//               <Link to="/product" className="button">
//                 Continue To Shopping
//               </Link>
//               {(totalAmount !== null || totalAmount !== 0) && (
//                 <div className="d-flex flex-column align-items-end">
//                   <h4>
//                     SubTotal: Rs.{" "}
//                     {!userCartState?.length ? 0 : totalAmount ? totalAmount : 0}
//                   </h4>
//                   <p>Taxes and shipping calculated at checkout</p>
//                   <Link to="/checkout" className="button">
//                     Checkout
//                   </Link>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </Container>
//     </>
//   );
// };

// export default Cart;


import React, { useEffect, useState } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCartProduct,
  getUserCart,
  updateCartProduct,
} from "../features/user/userSlice";

const Cart = () => {
  const dispatch = useDispatch();

  // Retrieve user token from localStorage
  const getTokenFromLocalStorage = localStorage.getItem("customer")
    ? JSON.parse(localStorage.getItem("customer"))
    : null;

  // Config headers for API calls
  const config2 = {
    headers: {
      Authorization: `Bearer ${getTokenFromLocalStorage?.token || ""}`,
      Accept: "application/json",
    },
  };

  const [productUpdateDetail, setProductUpdateDetail] = useState(null);
  const userCartState = useSelector((state) => state.auth.cartProducts || []);
  const [totalAmount, setTotalAmount] = useState(0);

  // Fetch user cart on mount
  useEffect(() => {
    dispatch(getUserCart(config2));
  }, [dispatch]);

  // Update cart when product quantity changes
  useEffect(() => {
    if (productUpdateDetail) {
      dispatch(updateCartProduct(productUpdateDetail));
      setTimeout(() => dispatch(getUserCart(config2)), 200);
    }
  }, [productUpdateDetail, dispatch]);

  // Calculate total amount
  useEffect(() => {
    const sum = userCartState.reduce(
      (acc, item) => acc + Number(item.quantity) * item.price,
      0
    );
    setTotalAmount(sum);
  }, [userCartState]);

  // Delete a product from cart
  const deleteACartProduct = (id) => {
    dispatch(deleteCartProduct({ id, config2 }));
    setTimeout(() => dispatch(getUserCart(config2)), 200);
  };

  return (
    <>
      <Meta title="Cart" />
      <BreadCrumb title="Cart" />
      <Container class1="cart-wrapper home-wrapper-2 py-5">
        <div className="row">
          <div className="col-12">
            {/* Cart Header */}
            <div className="cart-header py-3 d-flex justify-content-between align-items-center">
              <h4 className="cart-col-1">Product</h4>
              <h4 className="cart-col-2">Price</h4>
              <h4 className="cart-col-3">Quantity</h4>
              <h4 className="cart-col-4">Total</h4>
            </div>

            {/* Cart Items */}
            {userCartState.length > 0 ? (
              userCartState.map((item, index) => (
                <div
                  key={item?._id || index}
                  className="cart-data py-2 mb-1 d-flex justify-content-between align-items-center"
                >
                  {/* Product Details */}
                  <div className="cart-col-1 gap-10 d-flex align-items-center">
                    <div className="w-25">
                      <img
                        src={item?.productId?.images?.[0]?.url || "https://via.placeholder.com/100"}
                        className="img-fluid rounded lg:h-[60px] md:h-auto"
                        alt="product"
                      />
                    </div>
                    <div className="w-75">
                      <p>{item?.productId?.title || "Product Title"}</p>
                      <p className="d-flex gap-3">
                        Color:
                        <ul className="colors ps-0">
                          <li
                            style={{
                              backgroundColor: item?.color?.title || "#ccc",
                            }}
                          ></li>
                        </ul>
                      </p>
                    </div>
                  </div>

                  {/* Price */}
                  <div className="cart-col-2">
                    <h5 className="price">Rs. {item?.price || 0}</h5>
                  </div>

                  {/* Quantity Input */}
                  <div className="cart-col-3 d-flex align-items-center gap-15">
                    <input
                      className="form-control"
                      type="number"
                      min={1}
                      max={10}
                      value={item?.quantity || 1}
                      onChange={(e) =>
                        setProductUpdateDetail({
                          cartItemId: item?._id,
                          quantity: e.target.value,
                        })
                      }
                    />
                    <AiFillDelete
                      onClick={() => deleteACartProduct(item?._id)}
                      className="text-danger cursor-pointer"
                    />
                  </div>

                  {/* Total Price */}
                  <div className="cart-col-4">
                    <h5 className="price">
                      Rs. {(item?.quantity || 1) * (item?.price || 0)}
                    </h5>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center text-muted py-3">Your cart is empty.</p>
            )}
          </div>

          {/* Cart Footer */}
          <div className="col-12 py-2 mt-4">
            <div className="d-flex justify-content-between align-items-baseline">
              <Link to="/product" className="button">
                Continue Shopping
              </Link>
              {totalAmount > 0 && (
                <div className="d-flex flex-column align-items-end">
                  <h4>SubTotal: Rs. {totalAmount}</h4>
                  <p>Taxes and shipping calculated at checkout</p>
                  <Link to="/checkout" className="button">
                    Checkout
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Cart;
